import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'interactive-map',
  templateUrl: './interactive-map.component.html',
  styleUrls: ['./interactive-map.component.scss']
})
export class InteractiveMapComponent implements OnInit {
  @Input()
  continents; // Passed from course-area-location-filter
  @Output()
  selectLocation = new EventEmitter<any>(); // Permit parent method call

  constructor() {}

  ngOnInit() {}

  countrySelected(id: string) {
    const continent = this.continents.find(cont => cont.id === id);

    if (['UK', 'IE'].includes(id)) {
      return (
        continent.selected ||
        continent.options.some(
          country => country.selected || country.options.some(county => county.selected)
        )
      );
    } else {
      if (continent) {
        return continent.selected;
      }

      for (const cont of this.continents) {
        const country = cont.options.find(c => c.id === id);
        if (country) {
          return country.selected;
        }
      }
    }
  }

  clickCountry(event) {
    const target = event.target || event.srcElement || event.currentTarget;

    const continent = this.continents.find(cont => cont.id === target.attributes.id.value);

    if (continent && !continent.selected && continent.options.some(country => country.selected)) {
      continent.selected = true;
      continent.options.forEach(option => (option.selected = true));

      this.selectLocation.emit(continent);
      return;
    }

    if (continent) {
      this.selectLocation.emit(continent);
      return;
    }

    for (const cont of this.continents) {
      const country = cont.options.find(c => c.id === target.attributes.id.value);
      if (country) {
        this.selectLocation.emit(country);
        return;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/interactive-map/interactive-map.component.ts